// Props for the useU2104LoadLogicalUnitActionHandlers hook
export interface U2104LoadLogicalUnitActionHandlersParams<T = any> {
  doLoadLogicalUnitFn: () => Promise<any>;
  onSuccess?: (rows: T[]) => void;
  onError?: (errors: { error: any }) => void;
}

// Return type for the useU2104LoadLogicalUnitActionHandlers hook
export interface U2104LoadLogicalUnitActionHandlersReturn {
  loadLogicalUnitActions: () => void;
}

// Handlers for loading logical unit actions
export function useU2104LoadLogicalUnitActionHandlers<T extends { id: string } = any>({
  doLoadLogicalUnitFn,
  onSuccess,
  onError,
}: U2104LoadLogicalUnitActionHandlersParams<T>): U2104LoadLogicalUnitActionHandlersReturn {
  const loadLogicalUnitActions = async () => {
    try {
      const response = await doLoadLogicalUnitFn();
      const rows: T[] = response.data.results as unknown as T[];

      if (onSuccess) {
        onSuccess(rows);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { loadLogicalUnitActions };
}
